module.exports = __webpack_public_path__ + "img/kangjiatun2.b85a0cd2.png";